<template>
  <div>
    <div class="title-box">
      <span class="title">{{ moduleData.affiliationType }}</span>
    </div>
    <el-row :gutter="16">
      <template v-for="item in moduleData.subs" :key="item.field">
        <el-col :span="8" v-if="item.show">
          <el-form-item
            :label="item.title"
            :rules="getRules(item)"
            :key="item.field"
            :prop="item.field"
          >
            <div class="val">
              <Render
                :data="item"
                :value="getValue(item, formData)"
                ref="renderRef"
                :disabled="item.disabled"
                :isTxt="item.isTxt || allText"
                :comp-name="item.customField.renderConfig.compName"
                :renderConfig="item.customField.renderConfig"
                @changeValue="value => changeValue(value, item, formData)"
              />
            </div>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
  </div>
</template>

<script setup lang="ts">
import Render from '@/components/custom/form/components/render.vue'
import { fieldTypeConfig } from '@/enums/preObjectManage'
import { dealFormValConfig, ruleStrategy } from '@/utils/preObjectManage/utils'
import { getAmountRules } from '@/views/erp/unit'

const tableVisible = inject('tableVisible') as Fn

const props = defineProps({
  moduleData: {
    type: Object,
    default: () => {}
  },
  formData: {
    type: Object,
    default: () => {}
  },
  originFormData: {
    type: Object,
    default: () => {}
  }
})

function getValue(item: Recordable, formData: Recordable) {
  let customCode = item.type
  const getValueFn = dealFormValConfig[customCode]
    ? dealFormValConfig[customCode].getValue
    : () => formData[item.field] || ''
  return getValueFn(item, formData)
}

function changeValue(val: string, item: Recordable, formData: Recordable) {
  // item.value = val
  if (item.type === fieldTypeConfig.select) {
    tableVisible(item, val)
  }
  let customCode = item.type
  const setValueFn = dealFormValConfig[customCode]
    ? dealFormValConfig[customCode].setValue
    : () => {
        formData[item.field] = val
      }
  setValueFn(val, item, formData)
}

function getRules(item: Recordable) {
  let res: Recordable[] = []
  const requiredRule = {
    required: true,
    message: `${item.title}必填`,
    trigger: [
      fieldTypeConfig.department,
      fieldTypeConfig.personMultiple,
      fieldTypeConfig.select,
      fieldTypeConfig.singleLineText,
      fieldTypeConfig.phone,
      fieldTypeConfig.picture,
      fieldTypeConfig.person
    ].includes(item.type)
      ? 'change'
      : 'blur'
  }

  // 必填
  if (item.checkedInput === 1 || item.required) {
    // 必填就放到规则中去
    res.push(requiredRule)
  }
  res = res.concat(getAmountRules(item))
  const otherRule = ruleStrategy[item.type]
  if (otherRule) res.push(otherRule(item))
  if (item.field === 'expectLoanMoney') {
    console.log(res, 'expectLoanMoney')
  }
  return res
}

function getData() {
  return props.formData
}

function getChangeList() {
  let list: Recordable = []
  props.moduleData.subs.forEach((item: Recordable) => {
    if (props.originFormData[item.field]?.toString() !== props.formData[item.field]) {
      // 附件 图片 地址不传新旧值
      let arr = [fieldTypeConfig.address, fieldTypeConfig.picture, fieldTypeConfig.enclosure]
      list.push({
        columnId: item.id,
        columnSerial: item.field,
        fieldName: item.title,
        oldValue: arr.includes(item.type) ? '' : props.originFormData[item.field],
        newValue: arr.includes(item.type) ? '' : props.formData[item.field]
      })
    }
  })
  return list
}

function validate() {
  let err = ''
  props.moduleData.subs.forEach((item: Recordable) => {
    if ((item.required || item.checkedInput === 1) && !props.formData[item.field]) {
      err = err || `${item.title}必填`
    }
  })
  return err
}

function triggerVisible() {
  props.moduleData.subs.forEach((item: Recordable) => {
    if (item.showHideRule) {
      tableVisible(item, props.formData[item.field])
    }
  })
}

defineExpose({
  getData,
  validate,
  getChangeList
})

const allText = ref(true)
onMounted(() => {
  setTimeout(() => {
    allText.value = false
  }, 300)
  triggerVisible()
})
</script>
<style lang="scss" scoped>
.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 38px;
  .btn-box {
    display: flex;
  }

  .title {
    font-size: 14px;
    color: #333333;
    font-weight: 700;
    display: inline-block;
    border-left: 3px solid #5687ff;
    padding-left: 9px;
  }
}
</style>
